﻿/*
 * Copyright (c) 2022 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { MatriculadoResponse } from './../_models/matriculado';
import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MatriculadoService {

    matriculado: EventEmitter<any> = new EventEmitter<any>();
    constructor(private http: HttpClient) {

    }

    getMatriculado() {
        const matriculado = sessionStorage.getItem('matriculado');
        return matriculado;
    }
    loadMatriculado() {
        this.getInfo().toPromise().then(datos => {
            let matriculado = datos.registros[0];
            sessionStorage.setItem('matriculado', JSON.stringify(matriculado));
            this.matriculado.emit(matriculado);
        });
    }
    getInfo() {
        return this.http.get<MatriculadoResponse>(environment.apiUrl + '/api/v1/matriculados');
    }

}
